

// src/components/skeletons/ClientSkeleton.jsx
import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const AnimeSkeleton = ({ 
  rows = 5, 
  cols = 4,
  skeletonHeight = 16,
  skeletonPadding = "10px 0",
  borderRadius = 4,
  baseColor = "rgba(224, 224, 224, 0.4)",
  highlightColor = "rgba(245, 245, 245, 0.6)"
}) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={`row-${rowIndex}`}>
          {Array.from({ length: cols }).map((_, colIndex) => (
            <td key={`col-${colIndex}`}>
              <Skeleton
                style={{ padding: skeletonPadding }}
                height={skeletonHeight}
                borderRadius={borderRadius}
                baseColor={baseColor}
                highlightColor={highlightColor}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default AnimeSkeleton;